import React, { useState } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import InventoryIcon from '@mui/icons-material/Inventory';

const GranelSection = ({
  granelRecords = [],
  destilacionRecords = [],
  isFormOpen,
  setIsFormOpen,
  formData = {},
  setFormData,
  handleSaveGranel,
  handleCancelGranel,
  handleRejectGranel
}) => {
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Estado para Modal de Fusión / Mezcla de Graneles
  const [isFusionModalOpen, setIsFusionModalOpen] = useState(false);
  const [fusionSources, setFusionSources] = useState([
    { granelId: "", volExtraer: "" },
    { granelId: "", volExtraer: "" }
  ]);
  const [fusionNuevoLote, setFusionNuevoLote] = useState("");
  const [fusionNuevoContenedor, setFusionNuevoContenedor] = useState("");
  const [fusionObservaciones, setFusionObservaciones] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleLoteSelect = (e) => {
    const selectedNoLote = e.target.value;

    const destRecord = (destilacionRecords || []).find(
      r => r.noProduccion === selectedNoLote || r.id?.toString() === selectedNoLote
    );

    if (destRecord) {
      let tieneDestiladoCon = false;
      let ingredienteArray = [];

      if (destRecord.items && Array.isArray(destRecord.items)) {
        destRecord.items.forEach(it => {
          if (it.esDestiladoCon || (it.destiladoConIngrediente && it.destiladoConIngrediente.trim() !== '')) {
            tieneDestiladoCon = true;
          }
          if (it.destiladoConIngrediente && it.destiladoConIngrediente.trim() !== '') {
            ingredienteArray.push(it.destiladoConIngrediente.trim());
          } else if (it.destiladoConIngredientes && Array.isArray(it.destiladoConIngredientes)) {
            ingredienteArray.push(...it.destiladoConIngredientes);
          }
        });
      } else if (destRecord.esDestiladoCon || destRecord.destiladoConIngrediente) {
        tieneDestiladoCon = true;
        if (destRecord.destiladoConIngrediente) ingredienteArray.push(destRecord.destiladoConIngrediente);
      }

      const ingredientesUnicos = [...new Set(ingredienteArray.filter(Boolean))].join(', ');
      const claseAuto = tieneDestiladoCon ? "Destilado con" : (destRecord.clase || "Joven / Blanco");

      let totalVol = 0;
      let totalAlcVolSum = 0;
      if (destRecord.items && Array.isArray(destRecord.items)) {
        destRecord.items.forEach(it => {
          const vol = Number(it.volumenMezcal || 0);
          const alc = Number(it.pctAlcMezcal || 0);
          totalVol += vol;
          totalAlcVolSum += (vol * alc);
        });
      }
      const alcPonderado = totalVol > 0 ? (totalAlcVolSum / totalVol).toFixed(1) : (destRecord.pctAlcMezcal || "");

      setFormData(prev => ({
        ...prev,
        noLote: selectedNoLote,
        clase: claseAuto,
        ingredientes: ingredientesUnicos || prev.ingredientes || "",
        tipoMaguey: destRecord.tipoMaguey || prev.tipoMaguey || "",
        categoria: destRecord.categoria || prev.categoria || "Mezcal",
        noAnalisis: destRecord.noAnalisis || destRecord.noInforme || prev.noAnalisis || "",
        invInicialVol: totalVol > 0 ? totalVol.toString() : (prev.invInicialVol || ""),
        invInicialAlc: alcPonderado ? alcPonderado.toString() : (prev.invInicialAlc || ""),
        entradaVolumen: totalVol > 0 ? totalVol.toString() : (prev.entradaVolumen || ""),
        entradaAlc: alcPonderado ? alcPonderado.toString() : (prev.entradaAlc || ""),
        invFinalVol: totalVol > 0 ? totalVol.toString() : (prev.invFinalVol || ""),
        invFinalAlc: alcPonderado ? alcPonderado.toString() : (prev.invFinalAlc || "")
      }));
    } else {
      setFormData(prev => ({ ...prev, noLote: selectedNoLote }));
    }
  };

  const handleEditRecord = (rec) => {
    if (rec.status !== "borrador" && rec.status !== "rechazado") {
      alert("Solo se pueden editar registros que se encuentren en estado BORRADOR o RECHAZADO.");
      return;
    }
    setFormData({
      fechaMovimiento: rec.fechaMovimiento || "",
      idContenedor: rec.idContenedor || "",
      noLote: rec.noLote || "",
      categoria: rec.categoria || "Mezcal",
      clase: rec.clase || "Joven / Blanco",
      ingredientes: rec.ingredientes || "",
      edad: rec.edad || "",
      tipoMaguey: rec.tipoMaguey || "",
      noAnalisis: rec.noAnalisisFisicoquimico || rec.noAnalisis || "",
      observaciones: rec.observaciones || ""
    });
    setIsFormOpen(true);
  };

  // Manejo de Fusión / Mezcla de Lotes de Granel
  const handleAddFusionSource = () => {
    setFusionSources(prev => [...prev, { granelId: "", volExtraer: "" }]);
  };

  const handleRemoveFusionSource = (idx) => {
    if (fusionSources.length <= 2) {
      alert("Debe seleccionar al menos 2 lotes origen para realizar una fusión/mezcla.");
      return;
    }
    setFusionSources(prev => prev.filter((_, i) => i !== idx));
  };

  const handleFusionSourceChange = (idx, field, value) => {
    setFusionSources(prev => {
      const copy = [...prev];
      copy[idx] = { ...copy[idx], [field]: value };
      return copy;
    });
  };

  const handleExecuteFusion = () => {
    const validSources = fusionSources.filter(s => s.granelId && parseFloat(s.volExtraer) > 0);
    if (validSources.length < 2) {
      alert("Por favor seleccione al menos 2 lotes de granel con volumen a extraer positivo.");
      return;
    }

    if (!fusionNuevoLote) {
      alert("Ingrese el Nuevo Número de Lote para la mezcla.");
      return;
    }

    let totalVolMezcla = 0;
    let totalAlcVolPonderado = 0;
    let ingredientesList = [];
    let magueyesList = [];
    let categoriaBase = "Mezcal";
    let claseBase = "Joven / Blanco";

    validSources.forEach(src => {
      const gRecord = granelRecords.find(g => (g.id === src.granelId || g.noLote === src.granelId || g.idContenedor === src.granelId));
      if (gRecord) {
        const vol = parseFloat(src.volExtraer);
        const alc = parseFloat(gRecord.invFinalAlc || gRecord.entradaAlc || 45);
        totalVolMezcla += vol;
        totalAlcVolPonderado += (vol * alc);

        if (gRecord.ingredientes) ingredientesList.push(gRecord.ingredientes);
        if (gRecord.tipoMaguey) magueyesList.push(gRecord.tipoMaguey);
        if (gRecord.categoria) categoriaBase = gRecord.categoria;
        if (gRecord.clase) claseBase = gRecord.clase;
      }
    });

    const alcPonderadoMezcla = totalVolMezcla > 0 ? (totalAlcVolPonderado / totalVolMezcla).toFixed(1) : "45";
    const ingredientesUnicos = [...new Set(ingredientesList.filter(Boolean))].join(', ');
    const magueyesUnicos = [...new Set(magueyesList.filter(Boolean))].join(', ');

    // Pre-poblar el formulario de Granel con la mezcla consolidada
    setFormData({
      fechaMovimiento: new Date().toISOString().split('T')[0],
      idContenedor: fusionNuevoContenedor || `TANQUE-FUS-${Date.now().toString().slice(-4)}`,
      noLote: fusionNuevoLote,
      categoria: categoriaBase,
      clase: `${claseBase} (Mezcla/Fusión)`,
      ingredientes: ingredientesUnicos,
      tipoMaguey: magueyesUnicos,
      invInicialVol: totalVolMezcla.toString(),
      invInicialAlc: alcPonderadoMezcla,
      entradaProcedencia: `Mezcla/Fusión de ${validSources.length} lotes`,
      entradaVolumen: totalVolMezcla.toString(),
      entradaAlc: alcPonderadoMezcla,
      invFinalVol: totalVolMezcla.toString(),
      invFinalAlc: alcPonderadoMezcla,
      observaciones: fusionObservaciones || `Lote creado por fusión de ${validSources.length} registros de granel.`
    });

    setIsFusionModalOpen(false);
    setIsFormOpen(true);
  };

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header" style={{ marginBottom: "20px" }}>
          <div>
            <h2 style={{ fontSize: "20px", fontWeight: 800, color: "var(--agave-green)" }}>
              Inventarios de Mezcal a Granel (Sección V)
            </h2>
            <p style={{ margin: "4px 0 0 0", color: "var(--text-muted)", fontSize: "13px" }}>
              Control oficial de tanques, garrafas y fusiones/mezclas de graneles
            </p>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => setIsFusionModalOpen(true)}
              className="btn-secondary-custom"
              style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", background: "rgba(155, 89, 182, 0.15)", color: "#9b59b6", border: "1px solid rgba(155, 89, 182, 0.3)" }}
            >
              <MergeTypeIcon style={{ fontSize: 18 }} />
              <span style={{ fontWeight: 700 }}>Mezclar / Juntar Graneles</span>
            </button>

            <button
              onClick={() => {
                setFormData({
                  fechaMovimiento: new Date().toISOString().split('T')[0],
                  idContenedor: "",
                  noLote: "",
                  categoria: "Mezcal",
                  clase: "Joven / Blanco",
                  invInicialVol: "",
                  invInicialAlc: "",
                  entradaVolumen: "",
                  entradaAlc: "",
                  invFinalVol: "",
                  invFinalAlc: ""
                });
                setIsFormOpen(true);
              }}
              className="btn-add-new"
              style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 18px" }}
            >
              <AddIcon style={{ fontSize: 20 }} />
              <span style={{ fontWeight: 700 }}>Nuevo Movimiento a Granel</span>
            </button>
          </div>
        </div>

        <div className="records-list-wrapper" style={{ borderRadius: "14px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.08)" }}>
          <table className="records-table">
            <thead>
              <tr>
                <th>Fecha Mov.</th>
                <th>ID Contenedor / Nº Lote</th>
                <th>Categoría / Clase</th>
                <th>Tipo de Maguey</th>
                <th>Nº Análisis</th>
                <th>Revisor (V.Bo. Inspector)</th>
                <th>Estado</th>
                <th style={{ textAlign: "center" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {granelRecords.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center", padding: "40px", color: "var(--text-muted)" }}>
                    <InventoryIcon style={{ fontSize: 40, opacity: 0.4, marginBottom: "8px" }} />
                    <p style={{ margin: 0, fontSize: "14px" }}>No hay registros de mezcal a granel disponibles.</p>
                  </td>
                </tr>
              ) : (
                granelRecords.map((rec, i) => (
                  <tr key={i}>
                    <td>{rec.fechaMovimiento}</td>
                    <td style={{ fontWeight: 800, color: "var(--agave-green)" }}>
                      {rec.idContenedor} <br />
                      <small style={{ color: "var(--text-muted)" }}>Lote: {rec.noLote}</small>
                    </td>
                    <td>
                      <strong>{rec.categoria}</strong> <br />
                      <small style={{ color: "var(--text-muted)" }}>{rec.clase}</small>
                    </td>
                    <td>{rec.tipoMaguey || "-"}</td>
                    <td>{rec.noAnalisisFisicoquimico || rec.noAnalisis || "-"}</td>
                    <td style={{ fontSize: "12px", fontWeight: 600 }}>{rec.inspector || "Pendiente V.Bo."}</td>
                    <td>
                      <span className={`badge-status ${rec.status}`}>
                        {rec.status === "aprobado"
                          ? "Aprobado"
                          : rec.status === "enviado"
                            ? "Enviado"
                            : rec.status === "revision"
                              ? "En revisión"
                              : rec.status === "rechazado"
                                ? "Rechazado (Para corrección)"
                                : (rec.status === "cancelada" || rec.status === "cancelado")
                                  ? "Cancelada"
                                  : "Borrador"}
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <div style={{ display: "flex", justifyContent: "center", gap: "6px" }}>
                        <button
                          type="button"
                          onClick={() => setSelectedRecord(rec)}
                          title="Ver Detalle Completo"
                          style={{ background: "rgba(52, 152, 219, 0.15)", color: "#3498db", border: "1px solid rgba(52, 152, 219, 0.3)", borderRadius: "6px", padding: "5px 8px", cursor: "pointer", display: "flex", alignItems: "center" }}
                        >
                          <VisibilityIcon style={{ fontSize: 16 }} />
                        </button>

                        <button
                          type="button"
                          onClick={() => handleEditRecord(rec)}
                          disabled={rec.status !== "borrador" && rec.status !== "rechazado"}
                          title={rec.status === "borrador" || rec.status === "rechazado" ? "Editar Registro" : "Solo editables en estado Borrador"}
                          style={{
                            background: rec.status === "borrador" || rec.status === "rechazado" ? "rgba(241, 196, 15, 0.15)" : "rgba(255,255,255,0.04)",
                            color: rec.status === "borrador" || rec.status === "rechazado" ? "#f1c40f" : "var(--text-muted)",
                            border: rec.status === "borrador" || rec.status === "rechazado" ? "1px solid rgba(241, 196, 15, 0.3)" : "1px solid rgba(255,255,255,0.08)",
                            borderRadius: "6px",
                            padding: "5px 8px",
                            cursor: rec.status === "borrador" || rec.status === "rechazado" ? "pointer" : "not-allowed",
                            display: "flex",
                            alignItems: "center"
                          }}
                        >
                          <EditIcon style={{ fontSize: 16 }} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* MODAL DETALLE */}
        {selectedRecord && (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999, padding: "20px" }}>
            <div className="detail-card animate-fadeIn" style={{ maxWidth: "750px", width: "100%", maxHeight: "90vh", overflowY: "auto", background: "#161b22", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "16px", padding: "24px", position: "relative" }}>
              <button
                onClick={() => setSelectedRecord(null)}
                style={{ position: "absolute", top: "16px", right: "16px", background: "rgba(255,255,255,0.05)", border: "none", borderRadius: "50%", padding: "6px", color: "var(--text-muted)", cursor: "pointer" }}
              >
                <CloseIcon />
              </button>

              <div style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "12px", marginBottom: "16px" }}>
                <h3 style={{ margin: 0, color: "var(--agave-green)", fontSize: "20px", fontWeight: 800 }}>
                  Detalle Granel: {selectedRecord.noLote} (Contenedor: {selectedRecord.idContenedor})
                </h3>
                <small style={{ color: "var(--text-muted)", fontSize: "12px" }}>Sección V - Inventario a Granel</small>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "14px" }}>
                <div><strong>Fecha Movimiento:</strong> {selectedRecord.fechaMovimiento}</div>
                <div><strong>Categoría / Clase:</strong> {selectedRecord.categoria} / {selectedRecord.clase}</div>
                <div><strong>Ingredientes:</strong> {selectedRecord.ingredientes || "Ninguno"}</div>
                <div><strong>Tipo Maguey:</strong> {selectedRecord.tipoMaguey || "-"}</div>
                <div><strong>Nº Análisis:</strong> {selectedRecord.noAnalisisFisicoquimico || selectedRecord.noAnalisis || "-"}</div>
                <div><strong>Inv. Inicial:</strong> {selectedRecord.invInicialVol} L ({selectedRecord.invInicialAlc}%)</div>
                <div><strong>Entradas:</strong> {selectedRecord.entradaVolumen} L ({selectedRecord.entradaAlc}%) - {selectedRecord.entradaProcedencia}</div>
                <div><strong>Salidas:</strong> {selectedRecord.salidaVolumen} L ({selectedRecord.salidaAlc}%) - {selectedRecord.salidaDestino}</div>
                <div><strong>Inv. Final:</strong> <span style={{ color: "var(--agave-green)", fontWeight: 800 }}>{selectedRecord.invFinalVol} L ({selectedRecord.invFinalAlc}%)</span></div>
              </div>

              <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                <strong>Observaciones:</strong>
                <p style={{ margin: "6px 0 0 0", color: "var(--text-muted)", fontSize: "13px" }}>{selectedRecord.observaciones || "Sin observaciones."}</p>
              </div>

              <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button onClick={() => setSelectedRecord(null)} className="btn-secondary-custom" style={{ padding: "8px 16px" }}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL FUSION / MEZCLA DE GRANELES */}
        {isFusionModalOpen && (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backdropFilter: "blur(5px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999, padding: "20px" }}>
            <div className="detail-card animate-fadeIn" style={{ maxWidth: "700px", width: "100%", maxHeight: "90vh", overflowY: "auto", border: "1px solid rgba(155, 89, 182, 0.4)", borderRadius: "16px", padding: "24px", position: "relative" }}>
              <button
                onClick={() => setIsFusionModalOpen(false)}
                style={{ position: "absolute", top: "16px", right: "16px", background: "transparent", border: "none", color: "var(--text-muted)", cursor: "pointer" }}
              >
                <CloseIcon />
              </button>

              <div style={{ display: "flex", alignItems: "center", gap: "12px", borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "12px", marginBottom: "16px" }}>
                <MergeTypeIcon style={{ color: "#9b59b6", fontSize: 28 }} />
                <div>
                  <h3 style={{ margin: 0, color: "#9b59b6", fontSize: "18px", fontWeight: 800 }}>Fusión / Mezcla de Lotes de Granel</h3>
                  <small style={{ color: "var(--text-muted)" }}>Seleccione 2 o más lotes existentes para extraer y consolidar en un nuevo registro</small>
                </div>
              </div>

              {fusionSources.map((src, idx) => (
                <div key={idx} style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "12px", padding: "10px", borderRadius: "10px" }}>
                  <div style={{ flex: 2 }}>
                    <select
                      value={src.granelId}
                      onChange={e => handleFusionSourceChange(idx, "granelId", e.target.value)}
                      className="custom-select-field"
                      style={{ padding: "14px" }}
                    >
                      <option value="">-- Seleccionar Granel Origen #{idx + 1} --</option>
                      {granelRecords.map((g, gIdx) => {
                        const entVol = parseFloat(g.entradaVolumen || g.invInicialVol || 0);
                        const salVol = parseFloat(g.salidaVolumen || 0);
                        const volDisp = g.invFinalVol !== undefined ? parseFloat(g.invFinalVol) : Math.max(0, entVol - salVol);
                        return (
                          <option key={gIdx} value={g.id || g.noLote}>
                            Lote: {g.noLote || g.idContenedor} - {g.categoria} {g.clase} (Disponible: {volDisp} L)
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div style={{ flex: 1 }}>
                    <input
                      type="number"
                      placeholder="Vol. extraído (L)"
                      value={src.volExtraer}
                      onChange={e => handleFusionSourceChange(idx, "volExtraer", e.target.value)}
                      className="custom-input-field"
                      style={{ padding: "14px" }}
                    />
                  </div>

                  {fusionSources.length > 2 && (
                    <button
                      onClick={() => handleRemoveFusionSource(idx)}
                      style={{ background: "rgba(231, 76, 60, 0.2)", color: "#e74c3c", border: "none", borderRadius: "6px", padding: "8px", cursor: "pointer" }}
                    >
                      <DeleteIcon style={{ fontSize: 18 }} />
                    </button>
                  )}
                </div>
              ))}

              <button
                type="button"
                onClick={handleAddFusionSource}
                style={{ background: "rgba(155, 89, 182, 0.2)", color: "#9b59b6", border: "1px solid rgba(155, 89, 182, 0.4)", borderRadius: "8px", padding: "8px 16px", cursor: "pointer", fontSize: "13px", fontWeight: 700, marginBottom: "20px", display: "flex", alignItems: "center", gap: 6 }}
              >
                <AddIcon style={{ fontSize: 16 }} />
                <span>+ Agregar Otro Lote a la Mezcla</span>
              </button>

              <div className="species-grid">
                <div className="custom-input-group">
                  <input
                    type="text"
                    value={fusionNuevoLote}
                    onChange={e => setFusionNuevoLote(e.target.value)}
                    className="custom-input-field"
                    placeholder="Ej. LOTE-MEZCLA-01"
                  />
                  <label className="custom-input-label">Nuevo Número de Lote</label>
                </div>

                <div className="custom-input-group">
                  <input
                    type="text"
                    value={fusionNuevoContenedor}
                    onChange={e => setFusionNuevoContenedor(e.target.value)}
                    className="custom-input-field"
                    placeholder="Ej. TANQUE-MEZCLA-01"
                  />
                  <label className="custom-input-label">ID Contenedor Resultante</label>
                </div>
              </div>

              <div className="custom-input-group">
                <textarea
                  value={fusionObservaciones}
                  onChange={e => setFusionObservaciones(e.target.value)}
                  className="custom-input-field"
                  style={{ height: "70px", resize: "none", padding: "12px" }}
                  placeholder="Detalles sobre la mezcla de volúmenes..."
                />
                <label className="custom-input-label">Notas de Fusión</label>
              </div>

              <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button onClick={() => setIsFusionModalOpen(false)} className="btn-secondary-custom" style={{ padding: "8px 16px" }}>
                  Cancelar
                </button>
                <button onClick={handleExecuteFusion} className="btn-primary-custom" style={{ padding: "8px 20px", background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)" }}>
                  Procesar Fusión / Mezcla
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header" style={{ marginBottom: "20px" }}>
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2 style={{ fontSize: "20px", fontWeight: 800, color: "var(--agave-green)" }}>
          Nuevo Movimiento de Inventario a Granel - Sección V
        </h2>
      </div>

      <div className="cards-container-grid">
        {/* DATOS DEL CONTENEDOR Y MEZCAL */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "16px", padding: "24px" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Identificación del Mezcal y Contenedor</h2>
              <p>Selección de lote validado de destilación o ingreso manual</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="date"
                name="fechaMovimiento"
                value={formData?.fechaMovimiento || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha Movimiento</label>
            </div>

            <div className="custom-input-group">
              <select
                name="noLote"
                value={formData?.noLote || ""}
                onChange={handleLoteSelect}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="">-- Seleccionar Lote (Destilación Validada) --</option>
                {destilacionRecords.map((r, idx) => (
                  <option key={idx} value={r.noProduccion}>
                    {r.noProduccion} ({r.mezcal || 'Destilado'})
                  </option>
                ))}
              </select>
              <label className="custom-input-label">Nº de Lote (Validado Destilación)</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                name="idContenedor"
                value={formData?.idContenedor || ""}
                onChange={handleChange}
                className="custom-input-field"
                placeholder="Ej. TANQUE-01 / GARRAFA-05"
              />
              <label className="custom-input-label">ID Contenedor</label>
            </div>

            <div className="custom-input-group">
              <select
                name="categoria"
                value={formData?.categoria || "Mezcal"}
                onChange={handleChange}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                name="clase"
                value={formData?.clase || "Joven / Blanco"}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Clase</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                name="ingredientes"
                value={formData?.ingredientes || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Ingrediente(s)</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                name="tipoMaguey"
                value={formData?.tipoMaguey || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Tipo de Maguey(es)</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                name="noAnalisis"
                value={formData?.noAnalisis || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Nº Análisis Fisicoquímico</label>
            </div>
          </div>
        </section>

        {/* INVENTARIOS Y ENTRADAS */}
        <section className="detail-card detail-card-accent-left-copper" style={{ gridColumn: "1 / -1", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "16px", padding: "24px" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <ScienceIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inventarios, Entradas y Salidas</h2>
              <p>Saldos de inicio, adición de agua de dilución o mezclas</p>
            </div>
          </header>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--copper)", marginBottom: "8px" }}>INVENTARIO INICIAL</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                name="invInicialVol"
                value={formData?.invInicialVol || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Volumen Inicial (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                step="0.1"
                name="invInicialAlc"
                value={formData?.invInicialAlc || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">% Alc. Vol. Inicial</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "12px" }}>ENTRADAS</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                name="entradaProcedencia"
                value={formData?.entradaProcedencia || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Procedencia de Entrada</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                name="entradaVolumen"
                value={formData?.entradaVolumen || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Volumen Entrada (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                step="0.1"
                name="entradaAlc"
                value={formData?.entradaAlc || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">% Alc. Vol.</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--text-color)", marginBottom: "8px", marginTop: "12px" }}>SALIDAS</h3>
          <div className="custom-input-group">
            <input
              type="text"
              name="salidaDestino"
              value={formData?.salidaDestino || ""}
              onChange={handleChange}
              className="custom-input-field"
            />
            <label className="custom-input-label">Destino de Salida (Ej. Maduración / Envasado)</label>
          </div>
          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                name="salidaVolumen"
                value={formData?.salidaVolumen || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">Volumen Salida (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                step="0.1"
                name="salidaAlc"
                value={formData?.salidaAlc || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">% Alc. Vol. Salida</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", marginBottom: "8px", marginTop: "12px" }}>INVENTARIO FINAL</h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                name="invFinalVol"
                value={formData?.invFinalVol || ""}
                onChange={handleChange}
                className="custom-input-field"
                style={{ fontWeight: 800, color: "var(--agave-green)" }}
              />
              <label className="custom-input-label">Volumen Final (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                step="0.1"
                name="invFinalAlc"
                value={formData?.invFinalAlc || ""}
                onChange={handleChange}
                className="custom-input-field"
              />
              <label className="custom-input-label">% Alc. Vol. Final</label>
              <span className="input-suffix">%</span>
            </div>
          </div>
        </section>

        {/* OBSERVACIONES */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "16px", padding: "24px" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <SettingsIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Observaciones de Inventario</h2>
              <p>Detalles o notas sobre mermas, trasvases o estabilización química</p>
            </div>
          </header>

          <div className="custom-input-group">
            <textarea
              id="granelObservaciones"
              name="observaciones"
              value={formData?.observaciones || ""}
              onChange={handleChange}
              className="custom-input-field"
              style={{ height: "90px", resize: "none", padding: "14px" }}
              placeholder="Mermas, ajustes de grado..."
            />
            <label className="custom-input-label" htmlFor="granelObservaciones">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row" style={{ marginTop: "24px", display: "flex", justifyContent: "flex-end", gap: "14px" }}>
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button
          type="button"
          className="btn-primary-custom"
          onClick={() => handleSaveGranel("revision")}
          style={{ padding: "12px 28px", borderRadius: "10px", display: "flex", alignItems: "center", gap: 8 }}
        >
          <CheckCircleIcon style={{ fontSize: 20 }} />
          <span style={{ fontWeight: 800 }}>Registrar Movimiento Sección V</span>
        </button>
      </div>
    </div>
  );
};

export default GranelSection;
